import { render, staticRenderFns } from "./AppInfoCard.vue?vue&type=template&id=627498da&scoped=true&"
import script from "./AppInfoCard.vue?vue&type=script&lang=js&"
export * from "./AppInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoCard.vue?vue&type=style&index=0&id=627498da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627498da",
  null
  
)

export default component.exports